var $b8070b0c4fe79aec$exports = {};
'use strict';
// ======= Form submit =========
// ===============================
async function $b8070b0c4fe79aec$var$loadCountryCodes() {
    try {
        const response = await fetch(`${"https://qkkalabs.com"}/blog/api/metadata?country_codes=true`);
        const data = await response.json();
        const countrySelect = document.getElementById("countryCode");
        // Clear existing options
        countrySelect.innerHTML = "";
        data.data.country_codes.forEach((country)=>{
            const option = document.createElement("option");
            option.value = country.value;
            option.textContent = country.label;
            option.dataset.code = country.value;
            option.dataset.label = country.label;
            countrySelect.appendChild(option);
        });
        // Default India selected
        countrySelect.value = "+91";
        // Show only code initially
        $b8070b0c4fe79aec$var$collapseToCode();
    } catch (error) {
        console.error("Error loading country codes:", error);
    }
}
const $b8070b0c4fe79aec$var$countrySelect = document.getElementById("countryCode");
let $b8070b0c4fe79aec$var$lastOpenedAt = 0;
function $b8070b0c4fe79aec$var$handleOpen() {
    $b8070b0c4fe79aec$var$restoreLabels();
    $b8070b0c4fe79aec$var$lastOpenedAt = Date.now();
}
function $b8070b0c4fe79aec$var$handleCloseOrSelect() {
    if (Date.now() - $b8070b0c4fe79aec$var$lastOpenedAt < 300) return;
    $b8070b0c4fe79aec$var$collapseToCode();
}
function $b8070b0c4fe79aec$var$restoreLabels() {
    Array.from($b8070b0c4fe79aec$var$countrySelect.options).forEach((option)=>{
        option.textContent = option.dataset.label;
    });
}
function $b8070b0c4fe79aec$var$collapseToCode() {
    $b8070b0c4fe79aec$var$restoreLabels();
    const selectedOption = $b8070b0c4fe79aec$var$countrySelect.options[$b8070b0c4fe79aec$var$countrySelect.selectedIndex];
    if (selectedOption) selectedOption.textContent = selectedOption.dataset.code;
}
// form submit function and captcha related code
// =============================================
let $b8070b0c4fe79aec$var$savedCaptchaCode = "";
// CAPTCHA API LOAD
const $b8070b0c4fe79aec$var$createCaptchaImage = async ()=>{
    const captchaBox = document.getElementById("captchaImage");
    if (captchaBox) captchaBox.innerHTML = '<div class="w-[9.375rem] h-[3.125rem] border border-white animate-pulse"></div>';
    try {
        const response = await fetch(`${"https://qkkalabs.com"}/blog/api/captcha`, {
            method: "GET"
        });
        if (!response.ok) throw new Error("Captcha API failed");
        const result = await response.json();
        $b8070b0c4fe79aec$var$savedCaptchaCode = result.captcha_0 || "";
        if (captchaBox) captchaBox.innerHTML = `
        <img
          src="${result.image_url?.replace('http:', 'https:')}"
          alt="captcha"
          class="h-[3.125rem] w-[8.375rem] object-contain rounded"
        />
      `;
    } catch (error) {
        console.error("Captcha Error:", error);
        if (captchaBox) captchaBox.innerHTML = '<div class="text-white text-xs">Captcha failed</div>';
    }
};
const $b8070b0c4fe79aec$var$testimonialSection = document.getElementById('testimonialSection');
const $b8070b0c4fe79aec$var$contactSection = document.getElementById('contactSection');
if ($b8070b0c4fe79aec$var$testimonialSection || $b8070b0c4fe79aec$var$contactSection) {
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                // Show full list while opening
                $b8070b0c4fe79aec$var$countrySelect?.addEventListener("mousedown", $b8070b0c4fe79aec$var$handleOpen);
                $b8070b0c4fe79aec$var$countrySelect?.addEventListener("focus", $b8070b0c4fe79aec$var$handleOpen);
                // Show only code after selection, click, or blur
                $b8070b0c4fe79aec$var$countrySelect?.addEventListener("change", $b8070b0c4fe79aec$var$collapseToCode);
                $b8070b0c4fe79aec$var$countrySelect?.addEventListener("blur", $b8070b0c4fe79aec$var$collapseToCode);
                $b8070b0c4fe79aec$var$countrySelect?.addEventListener("click", $b8070b0c4fe79aec$var$handleCloseOrSelect);
                // Load dropdown
                $b8070b0c4fe79aec$var$loadCountryCodes();
                $b8070b0c4fe79aec$var$createCaptchaImage();
                observer.unobserve($b8070b0c4fe79aec$var$testimonialSection) // Stop observing after loading
                ;
            }
        });
    }, {
        threshold: 0.5
    });
    observer.observe($b8070b0c4fe79aec$var$testimonialSection);
    observer.observe($b8070b0c4fe79aec$var$contactSection);
}
window.createCaptchaImage = $b8070b0c4fe79aec$var$createCaptchaImage;
// HELPERS
const $b8070b0c4fe79aec$var$focusField = (id)=>{
    const el = document.getElementById(id);
    if (el) el.focus();
};
// ===============================
// VALIDATIONS
// ===============================
const $b8070b0c4fe79aec$var$validateName = (name)=>{
    if (!name || name.length < 3) {
        alert("Please enter a valid full name (at least 3 characters).");
        $b8070b0c4fe79aec$var$focusField("fullName");
        return false;
    }
    return true;
};
const $b8070b0c4fe79aec$var$validateEmail = (email)=>{
    if (!email) {
        alert("Please enter your email address.");
        $b8070b0c4fe79aec$var$focusField("email");
        return false;
    }
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!pattern.test(email)) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        $b8070b0c4fe79aec$var$focusField("email");
        return false;
    }
    // Count dots in the local part (before @)
    const localPart = email.split("@")[0];
    const dotCount = (localPart.match(/\./g) || []).length;
    if (dotCount > 2) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        $b8070b0c4fe79aec$var$focusField("email");
        return false;
    }
    return true;
};
const $b8070b0c4fe79aec$var$validatePhone = (phone)=>{
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length < 7 || cleaned.length > 15) {
        alert("Please enter a valid phone number (7 to 15 digits) with country code.");
        $b8070b0c4fe79aec$var$focusField("Phone_number");
        return null;
    }
    return cleaned;
};
const $b8070b0c4fe79aec$var$validateCaptcha = ()=>{
    const captchaInput = document.getElementById("captchaInput")?.value.trim();
    if (!captchaInput) {
        alert("Please enter the CAPTCHA code shown in the image.");
        $b8070b0c4fe79aec$var$focusField("captchaInput");
        return false;
    }
    return true;
};
const $b8070b0c4fe79aec$var$validateMessage = (message)=>{
    const trimmedMessage = message?.trim();
    // Optional field
    if (!trimmedMessage) return true;
    if (trimmedMessage.length < 10) {
        alert("Please enter a valid message (at least 10 characters).");
        $b8070b0c4fe79aec$var$focusField("message");
        return false;
    }
    return true;
};
// FORM SUBMIT
const $b8070b0c4fe79aec$var$FormSubmit = async (e)=>{
    e.preventDefault();
    const submitBtn = document.getElementById("form-button");
    if (submitBtn.disabled) return;
    // Honeypot check
    const honeypot = document.getElementById("honeypot");
    if (honeypot && honeypot.value !== "") return;
    const name = document.getElementById("fullName")?.value.trim();
    const email = document.getElementById("email")?.value.trim();
    const phoneRaw = document.getElementById("Phone_number")?.value.trim();
    const companyName = document.getElementById("company_name")?.value.trim();
    const message = document.getElementById("project")?.value.trim() || "";
    const captchaInput = document.getElementById("captchaInput")?.value.trim();
    const countrySelect = document.getElementById("countryCode");
    const areaOfInterest = document.getElementById("area_of_interest")?.value || "";
    const countryCode = countrySelect?.value || "";
    // Validations
    if (!$b8070b0c4fe79aec$var$validateName(name)) return;
    if (!$b8070b0c4fe79aec$var$validateEmail(email)) return;
    if (!$b8070b0c4fe79aec$var$validateMessage(message)) return;
    const cleanedPhone = $b8070b0c4fe79aec$var$validatePhone(phoneRaw || "");
    if (!cleanedPhone) return;
    if (!$b8070b0c4fe79aec$var$validateCaptcha()) return;
    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting...";
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", cleanedPhone);
    formData.append("company_name", companyName);
    formData.append("country_code", countryCode);
    formData.append("description", message);
    formData.append("area_of_interest", areaOfInterest);
    // Captcha API values
    formData.append("captcha_0", $b8070b0c4fe79aec$var$savedCaptchaCode);
    formData.append("captcha_1", captchaInput);
    // Extra fields
    formData.append("source", "contact-us");
    formData.append("user_agent", navigator.userAgent);
    try {
        const response = await fetch(`${"https://qkkalabs.com"}/blog/api/contact-us`, {
            method: "POST",
            body: formData
        });
        if (!response.ok) throw new Error("Form failed");
        const result = await response.json();
        // Save data
        if (result?.data?.name) localStorage.setItem("contact_name", result.data.name);
        if (result?.data?.email) localStorage.setItem("contact_email", result.data.email);
        // Redirect keep same
        window.location.href = "/thankyou";
    } catch (error) {
        console.error(error);
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit";
        $b8070b0c4fe79aec$var$createCaptchaImage();
    }
};
window.FormSubmit = $b8070b0c4fe79aec$var$FormSubmit;
// PAGE CACHE FIX
window.addEventListener("pageshow", (event)=>{
    if (event.persisted) window.location.reload();
});
// THANK YOU PAGE DATA
document.addEventListener("DOMContentLoaded", ()=>{
    const userName = document.getElementById("userName");
    const userEmail = document.getElementById("userEmail");
    if (userName) userName.textContent = localStorage.getItem("contact_name") || "No Name Found";
    if (userEmail) userEmail.textContent = localStorage.getItem("contact_email") || "No Email Found";
});
document.addEventListener("DOMContentLoaded", ()=>{
    const countrySelect = document.getElementById("countryCode");
    if (!countrySelect) return;
    // Save original option labels once
    const originalLabels = [
        ...countrySelect.options
    ].map((option)=>option.textContent);
    // Restore all original labels
    const restoreLabels = ()=>{
        [
            ...countrySelect.options
        ].forEach((option, index)=>{
            option.textContent = originalLabels[index];
        });
    };
    // Show selected country code only
    const collapseToCode = ()=>{
        restoreLabels();
        const selectedOption = countrySelect.options[countrySelect.selectedIndex];
        if (selectedOption?.dataset.code) selectedOption.textContent = selectedOption.dataset.code;
    };
    // Events
    countrySelect.addEventListener("focus", restoreLabels);
    countrySelect.addEventListener("change", ()=>{
        requestAnimationFrame(collapseToCode);
    });
    // Initial state
    collapseToCode();
});
const $b8070b0c4fe79aec$var$CONFIG = {
    idleTimeoutMs: 2000
};
function $b8070b0c4fe79aec$var$initFooterAccordion() {
    if (window.innerWidth >= 1024) return;
    const triggers = document.querySelectorAll('.footer-accordion-trigger');
    triggers.forEach((trigger)=>{
        const content = trigger.nextElementSibling;
        trigger.addEventListener('click', ()=>{
            const isOpen = content.classList.contains('open');
            document.querySelectorAll('.footer-accordion-content').forEach((el)=>el.classList.remove('open'));
            document.querySelectorAll('.footer-accordion-trigger').forEach((el)=>el.classList.remove('active'));
            if (!isOpen) {
                content.classList.add('open');
                trigger.classList.add('active');
            }
        });
    });
}
function $b8070b0c4fe79aec$var$getRobotsValue() {
    return "noindex, nofollow";
}
function $b8070b0c4fe79aec$var$createMetaGoogleBots() {
    const metaNew = document.createElement("meta");
    metaNew.setAttribute("name", "googlebot");
    metaNew.setAttribute("content", $b8070b0c4fe79aec$var$getRobotsValue());
    document.head.appendChild(metaNew);
}
function $b8070b0c4fe79aec$var$createMetaRobots() {
    const isProd = false;
    const content = isProd ? "index, follow" : "noindex, nofollow";
    const metaNew = document.createElement("meta");
    metaNew.setAttribute("name", "robots");
    metaNew.setAttribute("content", content);
    document.head.appendChild(metaNew);
}
function $b8070b0c4fe79aec$var$executeOnce() {
    $b8070b0c4fe79aec$var$initFooterAccordion();
    $b8070b0c4fe79aec$var$createMetaGoogleBots();
    $b8070b0c4fe79aec$var$createMetaRobots();
}
function $b8070b0c4fe79aec$var$mainHomePage() {
    if ('requestIdleCallback' in window) window.requestIdleCallback($b8070b0c4fe79aec$var$executeOnce, {
        timeout: $b8070b0c4fe79aec$var$CONFIG.idleTimeoutMs
    });
}
if (document.readyState === 'complete') $b8070b0c4fe79aec$var$mainHomePage();
else window.addEventListener('load', $b8070b0c4fe79aec$var$mainHomePage);


//# sourceMappingURL=index-cwv.35e35313.js.map
